import type { DashboardGaps } from '../../../hooks/useDashboardStats'

interface IncompleteTotalsBannerProps {
  gaps: DashboardGaps
}

/**
 * Says out loud that the totals beside it could not see everything.
 *
 * A partial total rendered as a whole is the defect #152/#159 exist for: a
 * confident number the user cannot tell is wrong, which changes between
 * reloads. Counting a gap without showing it would be the same bug with extra
 * bookkeeping, so every hook that populates `gaps` must render this.
 */
export default function IncompleteTotalsBanner({ gaps }: IncompleteTotalsBannerProps) {
  if (gaps.events === 0 && gaps.listPages === 0) {
    return null
  }

  const parts: string[] = []
  if (gaps.events > 0) {
    parts.push(`${gaps.events} ${gaps.events === 1 ? 'event' : 'events'} could not be loaded`)
  }
  if (gaps.listPages > 0) {
    parts.push(
      `${gaps.listPages} ${gaps.listPages === 1 ? 'page' : 'pages'} of your event list failed to load`
    )
  }

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 p-4" role="status">
      <p className="text-sm text-amber-800">
        <span className="font-medium">These totals are incomplete.</span> {parts.join('; ')}.
      </p>
    </div>
  )
}
